/*
 *  Copyright 2017-2026 Jason Schindler
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

/**
 * @summary A no-op logger that silently discards all warnings.
 *
 * @description
 * SilentLogger is used by Pubst when `showWarnings` is set to `false`.
 * It implements the same interface as ConsoleLogger but discards all messages.
 */
class SilentLogger {

  /**
   * @summary Discard a warning message (no-op).
   *
   * @param {string} source - The source of the warning.
   * @param {string} message - The warning message.
   */
  warn() {}
}

export default SilentLogger;
